<template>
  <div :class="['sidebar', isVertical && 'vertical']">
    <router-link
      v-for="option in options"
      :key="option.name"
      :to="{ name: option.routeName }"
      class="sidebar__element">
      <div class="sidebar__icon">
        <img
          class="sidebar__img"
          :src="require(`@/assets/icon/sidebar/${option.icon}`)"
          :alt="option.name" />
      </div>
      <div class="sidebar__name">{{ option.name }}</div>
    </router-link>
  </div>
</template>

<script setup>
import { defineProps } from 'vue'

defineProps({
  options: {
    type: Object,
    required: true,
  },
  isVertical: {
    type: Boolean,
    required: false,
    default: false,
  },
})
</script>
